import React, { useState, useEffect } from "react";
import "./Career_Banner.css";
import Start_Btn from "../../common/start-btn/Start_Btn";
import Fill_Form_Modal from "../../modals/fill-form-modal/Fill_Form_Modal";

const Career_Banner = ({ banner }) => {
  const [showModal, setShowModal] = useState(false);

  const decodeHTML = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };
  return (
    <>
      <section className="Career_Banner">
        <div className="container">
          <div className="career_content">
            <h5 className="career_title">
              {/* Professional Career Counselling for Clear & Confident Decisions */}
              {banner?.name}
            </h5>
            <p className="career_text">
              {/* Get expert guidance backed by structured assessments and detailed
            analysis to choose the right career path. */}
              {decodeHTML(banner?.description.replace(/<\/?[^>]+(>|$)/g, ""))}
            </p>
            <Start_Btn text="Book Session" onClick={() => setShowModal(true)} />
          </div>
        </div>
      </section>

      <Fill_Form_Modal
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </>
  );
};

export default Career_Banner;
